import { SERVICES } from "../lib/brand";
import { ScrollText, Fingerprint, Banknote, Compass } from "lucide-react";

const ICONS = { ScrollText, Fingerprint, Banknote, Compass };

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 lg:py-32 bg-navy">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="max-w-2xl">
          <p className="uppercase tracking-[0.2em] text-xs font-semibold text-gold mb-4">What we do</p>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight">
            Advisory engineered for <span className="gold-text">decisive outcomes</span>
          </h2>
          <p className="mt-6 text-slate-400 leading-relaxed">
            From contractual risk and intellectual property to funding eligibility and strategic
            decisions—we bring structure to complexity and confidence to every choice you make.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            const large = i === 0 || i === 3;
            return (
              <div
                key={s.key}
                data-testid={`service-card-${s.key}`}
                className={`group relative bg-navy-800 border border-white/10 p-8 lg:p-10 hover:-translate-y-2 hover:border-gold/50 transition-all duration-300 shadow-2xl shadow-black/40 ${
                  large ? "md:row-span-1" : ""
                }`}
              >
                <div className="w-14 h-14 flex items-center justify-center border border-gold/40 bg-gold/5 mb-7 group-hover:bg-gold group-hover:text-navy transition-colors text-gold">
                  <Icon className="w-7 h-7" strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-2xl mb-3">{s.title}</h3>
                <p className="text-slate-400 leading-relaxed">{s.desc}</p>
                <span className="absolute top-8 right-8 text-5xl font-display text-white/5 group-hover:text-gold/20 transition-colors">
                  0{i + 1}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
